<template>
<v-container fluid>
    <v-card class="ma-2" outlined>
        <v-card-title>
            <v-btn icon @click="goToUserList">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-icon class="mr-1" color="red">mdi-water</v-icon>
            เพิ่มผลเลือด
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            <v-btn color="primary" dark class="ml-5 mt-3" @click="addNewBloodTests">
                + ADD
            </v-btn>
        </v-card-title>
        <v-progress-linear indeterminate color="yellow darken-2" v-if="loading"></v-progress-linear>

        <!-- Dialog for confirm delete user -->
        <v-dialog v-model="dialogItem.deleteConfirmation" max-width="400px">
            <v-card>
                <v-card-title class="text">{{ dialogItem.confirmText }}</v-card-title>
                <v-card-actions v-if="dialogItem.confirmAction">
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeConfirmationDialog">OK</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
                <v-card-actions v-else>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="actionDeleteBloodTests">Yes</v-btn>
                    <v-btn color="blue darken-1" text @click="closeConfirmationDialog">No</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- table list -->
        <v-data-table v-if="bloodTestsList.length" :headers="headers" :items="bloodTestsList" :search="search" sort-by="no" :sort-desc="false" :footer-props="{ 'items-per-page-options': [10, 20, 30, 50, 100, -1] }" :options="options" :loading="loading" show-expand :single-expand="true" item-key="id">
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon class="mr-2" @click="editBloodTestsAction(item)" title="Edit" v-if="isAllowToManage">
                    mdi-pencil
                </v-icon>
                <v-icon v-if="isAllowToManage" class="mr-2" @click="dialogDeleteBloodTests(item)" title="Delete">
                    mdi-delete
                </v-icon>
            </template>
            <template v-slot:expanded-item="{ item }">
                <td :colspan="5" class="pa-6">
                    <v-container fluid>
                        <v-row v-for="k in headersRow" :key="k.key">
                            <v-col> {{ k.text }} </v-col>
                            <v-col> {{ item[k.value] }} </v-col>
                        </v-row>
                    </v-container>
                </td>
            </template>
        </v-data-table>
        <v-card-subtitle v-else>No item list</v-card-subtitle>
    </v-card>
</v-container>
</template>

<script>
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import {
    mapGetters
} from "vuex";
import bqGetBloodTestList from "../data/bqGetBloodTestList";
import removeHealthData from "../data/removeHealthData";
export default {
    name: 'BloodTestsList',
    metaInfo: {
        title: 'Blood Tests List'
    },
    data() {
        return {
            loading: false,
            search: "",
            options: {
                itemsPerPage: 20,
            },
            headers: [{
                    text: "วันที่",
                    value: "dateFormated"
                },
                {
                    text: "createdBy",
                    value: "createdName"
                },
                // {
                //     text: "glucose (mg/dL)",
                //     value: "glucose"
                // },
                // {
                //     text: "hba1c (%)",
                //     value: "hba1c"
                // },
                // {
                //     text: "cholesterol (mg/dL)",
                //     value: "cholesterol"
                // },
                // {
                //     text: "hdl (mg/dL)",
                //     value: "hdl"
                // },
                // {
                //     text: "ldl (mg/dL)",
                //     value: "ldl"
                // },
                // {
                //     text: "triglycerides (mg/dL)",
                //     value: "triglycerides"
                // },
                // {
                //     text: "creatinine (mg/dL)",
                //     value: "creatinine"
                // },
                // {
                //     text: "eGFR",
                //     value: "eGFR"
                // },
                // {
                //     text: "uricAcid (mg/dL)",
                //     value: "uricAcid"
                // },
                // {
                //     text: "ALT/SGPT (U/L)",
                //     value: "alt_sgpt"
                // },
                // {
                //     text: "ALP (U/L)",
                //     value: "alp"
                // },
                // {
                //     text: "AST/SGOT (U/L)",
                //     value: "ast_sgot"
                // },
                {
                    text: "Actions",
                    value: "actions",
                    sortable: false,
                },
            ],
            headersRow: [{
                    text: "วันที่",
                    value: "dateFormated"
                },
                {
                    text: "createdBy",
                    value: "createdName"
                },
                {
                    text: "glucose (mg/dL)",
                    value: "glucose"
                },
                {
                    text: "hba1c (%)",
                    value: "hba1c"
                },
                {
                    text: "cholesterol (mg/dL)",
                    value: "cholesterol"
                },
                {
                    text: "hdl (mg/dL)",
                    value: "hdl"
                },
                {
                    text: "ldl (mg/dL)",
                    value: "ldl"
                },
                {
                    text: "triglycerides (mg/dL)",
                    value: "triglycerides"
                },
                {
                    text: "creatinine (mg/dL)",
                    value: "creatinine"
                },
                {
                    text: "eGFR",
                    value: "eGFR"
                },
                {
                    text: "uricAcid (mg/dL)",
                    value: "uricAcid"
                },
                {
                    text: "ALT/SGPT (U/L)",
                    value: "alt_sgpt"
                },
                {
                    text: "ALP (U/L)",
                    value: "alp"
                },
                {
                    text: "AST/SGOT (U/L)",
                    value: "ast_sgot"
                }
            ],
            isAllowToManage: false,
            bloodTestsList: [],

            dialogItem: {
                confirmAction: false,
                confirmText: "Do you want to delete this bloodTests?",
                deleteConfirmation: false,
                deletedItemId: null,
            },
            dialogItemDefault: {
                confirmAction: false,
                confirmText: "Do you want to delete this bloodTests?",
                deleteConfirmation: false,
                deletedItemId: null,
            }
        };
    },
    created() {
        var vm = this;
        vm.$store.state.appTitle = "Thaisook Web Admin | BloodTests";
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                vm.$store.dispatch("autoSignIn", user);
                this.loading = true;
                setTimeout(() => {
                    vm.initialize();
                }, "1000");
            } else {
                console.log("no user");
            }
        });
    },
    computed: {
        ...mapGetters([
            "loggedInUserId",
            "isAuthenticated",
            "isSuperAdmin",
            "isChallengeAdmin",
        ]),
    },
    methods: {
        initialize() {
            if (this.isSuperAdmin || this.isChallengeAdmin) {
                this.isAllowToManage = true;
                (async () => {
                    this.bloodTestsList = await bqGetBloodTestList(this.$route.params.uid);
                    this.loading = false;
                })();
            } else {
                this.$router.push(`/dashboard`);
            }
        },
        // //dialog
        addNewBloodTests() {
            this.$router.push(`/program/${this.$route.params.mod}/bloodtests/${this.$route.params.id}/${this.$route.params.uid}/add`);
        },
        editBloodTestsAction(item) {
            this.$router.push(`/program/${this.$route.params.mod}/bloodtests/${this.$route.params.id}/${this.$route.params.uid}/${item.docId}`);
        },

        // //delete
        dialogDeleteBloodTests(item) {
            this.dialogItem.deleteConfirmation = true; //show popup
            this.dialogItem.deletedItemId = item.docId; //assign delete item id

            this.dialogItem.confirmAction = this.dialogItemDefault.confirmAction;
            this.dialogItem.confirmText = this.dialogItemDefault.confirmText;
        },
        actionDeleteBloodTests() {
            (async () => {
                await removeHealthData(this.$route.params.uid, this.dialogItem.deletedItemId);
                this.dialogItem.confirmAction = true;
                this.dialogItem.confirmText = "Done!";

                this.dialogItem.deleteConfirmation = false;
                this.dialogItem.deletedItemId = this.dialogItemDefault.deletedItemId; //assign delete item id
                await this.initialize();
            })();
        },
        closeConfirmationDialog() {
            //To result default value
            this.dialogItem.deleteConfirmation = false;
            this.dialogItem.deletedItemId = this.dialogItemDefault.deletedItemId; //assign delete item id
            this.dialogItem.confirmAction = this.dialogItemDefault.confirmAction;
            this.dialogItem.confirmText = this.dialogItemDefault.confirmText;
        },
        goToUserList() {
            this.$router.go(`-1`);
        }
    },
};
</script>
